import { ImageElement, InnerFooter, SweetAlert } from 'components';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import routesMap from 'routeControl/userRouteMap';
import { setSessionStorage } from 'utils';

function LayoutFour() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [themes, setThemes] = useState();
  const visibleFalse = () => {
    setIsAlertVisible(false);
    setThemes();
  };

  const themeData = [
    {
      imageUrl: 'theme01-2.jpg',
    },
    {
      imageUrl: 'theme02-2.jpg',
    },
    {
      imageUrl: 'theme03-2.jpg',
    },
    {
      imageUrl: 'theme04-2.jpg',
    },
  ];

  const onConfirmAlert = (index) => {
    setSessionStorage('theme', `theme0${index + 1}`);
    navigate(routesMap?.CREATEMEMORIALS?.path);
  };

  return (
    <>
      <main className="layoutFourPage bg-light-grey py-50 pb-0">
        <section className="pageTitle">
          <Container>
            <h1 className="fw-semibold">{t('text.common.chooseTheme')}</h1>
            <p className="mb-0">{t('text.theme.craftingMoment')}</p>
          </Container>
        </section>
        <section className="selectTheme pt-0 py-80">
          <Container>
            <Row className={`g-3 ${id === '1' && 'center'}`}>
              {themeData &&
                themeData?.length > 0 &&
                themeData?.slice(0, id)?.map((item, index) => (
                  <Col sm={id === '1' ? 8 : 6}>
                    <div className="layoutCard position-relative overflow-hidden">
                      <ImageElement className="w-100" source={item?.imageUrl} />
                      <div className="layoutCard_hoverbox d-flex align-items-center justify-content-center position-absolute top-0 start-0  w-100 h-100">
                        <Link
                          to={`/theme0${index + 1}`}
                          className="btn btn-white"
                        >
                          {t('text.common.livePreview')}
                        </Link>
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setIsAlertVisible(true);
                            setThemes(index);
                          }}
                          className="btn btn-danger"
                        >
                          {t('text.common.createMemorial')}
                        </Link>
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>
          </Container>
          <SweetAlert
            reverseButtons
            title="Life Legacy"
            text="You can’t change a theme once you have added info."
            show={isAlertVisible}
            icon="warning"
            showCancelButton
            cancelButtonText="Cancel"
            confirmButtonText="Ok"
            setIsAlertVisible={() => visibleFalse()}
            showLoaderOnConfirm
            // loading={loading}
            onConfirmAlert={() => onConfirmAlert(themes)}
          />
        </section>
      </main>
      <InnerFooter />
    </>
  );
}

export default LayoutFour;
